import { keyframes, style, styleVariants } from "@vanilla-extract/css";
import { fontRegularFamily } from "../theme/Fonts.css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

const slideIn = keyframes({
  from: {
    transform: "translateX(calc(100% + 24px))",
    opacity: 0
  },
  to: {
    transform: "translateX(0)",
    opacity: 1
  }
});

const slideOut = keyframes({
  from: {
    transform: "translateX(0)",
    opacity: 1
  },
  to: {
    transform: "translateX(calc(100% + 24px))",
    opacity: 0
  }
});

export const toastViewport = style({
  position: "fixed",
  bottom: 0,
  right: 0,
  display: "flex",
  flexDirection: "column",
  padding: primitiveTokens.sizing["6x"],
  gap: primitiveTokens.sizing["2.5x"],
  width: 390,
  maxWidth: "100vw",
  margin: 0,
  listStyle: "none",
  zIndex: 1002
});

const toastRootBase = style({
  borderRadius: primitiveTokens.radii.sm,
  boxShadow: primitiveTokens.colors.shadow.popover,
  padding: primitiveTokens.sizing["4x"],
  display: "flex",
  columnGap: primitiveTokens.sizing["4x"],
  alignItems: "flex-start",
  fontFamily: fontRegularFamily,
  selectors: {
    "&[data-state='open']": {
      animation: `${slideIn} 200ms cubic-bezier(0.16, 1, 0.3, 1)`
    },
    "&[data-state='closed']": {
      animation: `${slideOut} 200ms ease-in`
    }
  }
});

export const toastContent = style({
  flexGrow: 1,
  // An id or URL has no break points; it must wrap, not push the close
  // button off-screen.
  minWidth: 0,
  overflowWrap: "anywhere",
  display: "flex",
  flexDirection: "column"
});

export const toastVariants = styleVariants({
  default: [
    toastRootBase,
    {
      backgroundColor: semanticThemeTokens.toast.default.backgroundColor,
      border: `${primitiveTokens.borderWidth.default} solid ${semanticThemeTokens.toast.default.borderColor}`
    }
  ],
  success: [
    toastRootBase,
    {
      backgroundColor: semanticThemeTokens.toast.success.backgroundColor,
      border: `${primitiveTokens.borderWidth.default} solid ${semanticThemeTokens.toast.success.borderColor}`
    }
  ],
  warning: [
    toastRootBase,
    {
      backgroundColor: semanticThemeTokens.toast.warning.backgroundColor,
      border: `${primitiveTokens.borderWidth.default} solid ${semanticThemeTokens.toast.warning.borderColor}`
    }
  ],
  error: [
    toastRootBase,
    {
      backgroundColor: semanticThemeTokens.toast.error.backgroundColor,
      border: `${primitiveTokens.borderWidth.default} solid ${semanticThemeTokens.toast.error.borderColor}`
    }
  ]
});

const toastTitleBase = style({
  fontWeight: 500,
  fontSize: primitiveTokens.type.md,
  lineHeight: "normal"
});

export const toastTitleVariants = styleVariants({
  default: [
    toastTitleBase,
    { color: semanticThemeTokens.toast.default.titleColor }
  ],
  success: [
    toastTitleBase,
    { color: semanticThemeTokens.toast.success.titleColor }
  ],
  warning: [
    toastTitleBase,
    { color: semanticThemeTokens.toast.warning.titleColor }
  ],
  error: [toastTitleBase, { color: semanticThemeTokens.toast.error.titleColor }]
});

export const toastDescription = style({
  margin: 0,
  marginTop: primitiveTokens.sizing["1x"],
  color: semanticThemeTokens.toast.default.descriptionColor,
  fontSize: primitiveTokens.type.sm,
  lineHeight: 1.5,
  // A refusal lists one cell per line.
  whiteSpace: "pre-line"
});

export const toastClose = style({
  marginTop: "-10px"
});
